import React from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSwitcher.css";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${currentLang === "en" ? "active" : ""}`}
        onClick={() => changeLanguage("en")}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className="lang-divider">|</span>
      <button
        className={`lang-btn ${currentLang === "de" ? "active" : ""}`}
        onClick={() => changeLanguage("de")}
        aria-label="Switch to German"
      >
        DE
      </button>
    </div>
  );
};

export default LanguageSwitcher;
